import { default as ReactInputMask, Props as ReactInputMaskProps } from 'react-input-mask';
import { forwardRef } from 'react';
import styled from 'styled-components';

import { CustomTooltip } from '../atoms';
import { useAppSelector } from '../../hooks/hooksRedux';
import { RootState } from '../../store';
import { defaultColors } from '../../styles/style-guide';

interface InputProps extends Partial<Omit<ReactInputMaskProps, 'inputRef'>> {
  label?: string;
  error?: string;
  tooltip?: string;
}

export const StyledLabel = styled.label<{ $hasError: boolean; $colors?: string }>`
  color: ${({ $hasError, $colors }) => ($hasError ? '#ef4444' : $colors)};
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 400;
`;

// Envolvendo o componente com React.forwardRef
const InputComponent = forwardRef<HTMLInputElement, InputProps>((props, ref) => {
  const { label, error, tooltip, mask, ...rest } = props;

  const { colors } = useAppSelector((state: RootState) => state.styleGuide.data);
  const primaryColors = colors.primary || defaultColors.primary;

  return (
    <div className="flex w-full flex-col gap-1">
      {label && (
        <div className="flex flex-row items-center gap-3">
          <StyledLabel $hasError={!!error} $colors={primaryColors}>
            {label}
          </StyledLabel>

          {tooltip && <CustomTooltip content={tooltip} />}
        </div>
      )}

      <ReactInputMask
        mask={mask || ''}
        className={`${
          error ? 'border-red-500' : 'border-[#CED4DA]'
        } h-[40px] w-full rounded-lg border-[1px] bg-white px-4 text-sm text-slate-800 shadow-sm transition focus:border-blue-500 focus:ring-2 focus:ring-blue-500/30`}
        {...rest}
        value={typeof rest.value === 'number' ? String(rest.value) : typeof rest.value === 'string' ? rest.value : ''}
        inputRef={ref} // Encaminha o ref corretamente
      />
      <span className="text-xs text-red-500">{error}</span>
    </div>
  );
});

// Adiciona o displayName para depuração e exporta
InputComponent.displayName = 'InputComponent';

export const Input = InputComponent;
